import {Helmet} from 'react-helmet';
import AboutUs from "../../Page/aboutus";
import Testimonials from "../../Page/testimonials";
import Certificate from "../../Page/Certificate";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the role of a website designer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A website designer focuses on creating visually appealing, user-friendly, and responsive layouts for websites using tools like Figma, Adobe XD, and coding languages like HTML, CSS, and JavaScript."
      }
    },
    {
      "@type": "Question",
      "name": "How is a website designer different from a developer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A website designer handles the aesthetics and user experience (UI/UX) of a site, while a developer brings that design to life with coding. Designers prioritize visuals, developers focus on functionality."
      }
    },
    {
      "@type": "Question",
      "name": "Why hire a freelance website designer in Gurgaon?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Hiring a local freelance website designer in Gurgaon ensures timely communication, local insights, budget-friendly services, and better post-launch support."
      }
    },
    {
      "@type": "Question",
      "name": "Do you create mobile responsive designs?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I ensure every website is mobile-first and fully responsive across smartphones, tablets, and desktops for optimal user experience."
      }
    },
    {
      "@type": "Question",
      "name": "Which platforms do you design websites for?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I design websites for WordPress, Shopify, Webflow, HTML/CSS, and custom platforms based on your needs and business goals."
      }
    },
    {
      "@type": "Question",
      "name": "Can I see your previous design work?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, my portfolio is available at pankj.com/portfolio where you can view samples of website designs across different industries and styles."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to design a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most website design projects take 5–10 business days depending on the number of pages, complexity, and revisions involved."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer custom web design or use templates?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I offer fully custom designs as well as template-based designs depending on your budget and goals. Custom design ensures uniqueness and stronger branding."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be SEO-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I follow SEO best practices including clean code, fast loading times, image optimization, and proper HTML structure to help your site rank well."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of hiring a website designer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Website design pricing typically starts at ₹8,000 and goes up depending on complexity, number of pages, and features like animations or custom graphics."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
    <title>Pankaj - Website Designer</title>
  <meta name="description" content="Need a skilled website designer? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites."/>
  <meta name="keywords" content="pankaj, website designer, website designing company in gurgaon, web designer in gurgaon, website design in gurgaon, website maker in gurgaon, web design company in gurugram, web design gurugram, web designer gurugram, web development company in gurugram, website development agency gurgaon"/>
<meta property="og:title" content="Pankaj - Website Designer | website development company in gurgaon" />
<meta property="og:description" content="Need a skilled website designer? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites." />
<meta property="og:site_name" content="Pankaj - Website Designer | website development company in gurgaon" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-gurgaon"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj - Website Designer | website development company in gurgaon" />
<meta name="twitter:description" content="Need a skilled website designer? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites." />
<link rel="canonical" href="https://www.pankj.com/website-designer" />

        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
<video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer1.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg campaignpage">
<div className="container-fluid">
<div className="row">
<div className="col-lg-7 d-flex flex-column order-xs-2 order-xs-1">
<img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
<div className="multiple_effects fzsml" id="text3d"><span className="offers"></span></div>
<div className="content_sec" data-aos="fade-up" data-aos-delay="400">If you are looking for a <h1 className="headerdesign">Website Designer</h1>, then you are in the right place. Hello, I am pankaj with 10+ years of experience in website design & development. you can hire me as a freelancer for your dream projects.</div>
         <form action="https://www.pankj.com/php/campaign.php" method="post" className="php-email-form">
          <div className="claimnow"><i className="bi bi-gift"></i>&nbsp; Get a Website Today<strike>
       <i className="bi bi-currency-rupee"></i>10,000
    </strike> (<i className="bi bi-currency-rupee"></i>2,100 Only )<sup className="tcst"> T&C Apply*</sup></div>
              <div className="row gy-4">
                <div className="col-md-4 col-7">
                <input type="text" className="hiddenclasss" name="title" />
                  <input type="text" name="name" minLength="2" maxLength="20" id="name" className="form-control" placeholder="Your Name" required />
                </div>
                  <div className="col-md-3 col-5">
                  <input type="number" className="form-control" minLength="10" maxLength="13" name="phone" id="phone" placeholder="Your Phone" required />
                </div>
                <div className="col-md-5 col-sm-12 text-center mtss">
                  <input type="submit" className="form-control submitbtn" name="submit" placeholder="Submit" value="Claim Now(₹2100)Only*" onclick="return SubmitDetails();" />
                </div>

              </div>
            </form>
</div>
<div className="col-lg-5 hero-img order-xs-1 order-md-2" data-aos="zoom-out" data-aos-delay="200">
<div className="wrapper">
<div className="img-area">
<div className="inner-area">
<div className="bgimg"></div>
</div>
</div>

</div>
</div>

</div>
</div> 

</div>
</section> 

    <main id="main">
 <AboutUs />
<Testimonials/>
<Certificate />
</main>
    </>
  );
}
export default App1;
